import { lazy, useState, useEffect } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'
import { TypeComponentHubSpotForm } from '@/types/ctf'
import './newsletter.css'
import { cx } from '@/utils/strings'

const LazyHubspotForm = lazy(() => import('@/components/ui/hubspot-form'))

type NewsletterProps = {
  form: TypeComponentHubSpotForm<'WITHOUT_UNRESOLVABLE_LINKS'>['fields']
  size?: 'Small' | 'Large'
  /**
   * Card: Wraps the form in a card style container
   * Plain: No container around the form
   */
  variant?: 'Card' | 'Plain'
}

export default function Newsletter({ form, size = 'Large', variant = 'Card' }: NewsletterProps) {
  const [wasLoaded, setWasLoaded] = useState(false)
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
    rootMargin: '200px',
  })

  useEffect(() => {
    if (isIntersecting) {
      setWasLoaded(true)
    }
  }, [isIntersecting])

  const shouldShowForm = isIntersecting || wasLoaded

  return (
    <div
      className={cx('bw-newsletter', size === 'Small' && 'small', variant === 'Card' && 'bw-newsletter--card')}
      ref={ref}
    >
      {shouldShowForm ? <LazyHubspotForm {...form} shieldLoader="Xsmall" /> : <div className="h-[48px]" />}
    </div>
  )
}
